import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
export enum ClockAction {
  CLOCK_IN = 'CLOCK_IN',
  CLOCK_OUT = 'CLOCK_OUT',
}
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-clock-in-dialog',
  templateUrl: './confirmation-popup.component.html',
  styleUrls: ['./confirmation-popup.component.scss'],
})
export class ConfirmationPopUpComponent {
  title: string;
  message: string;
  message_two: string;
  warningMsg: string;
  location_home: string;
  location_office: string;
  lastClockIn = false;
  preDefined_max_clockIn_count: number;
  constructor(
    private translateService: TranslateService,
    public dialogRef: MatDialogRef<ConfirmationPopUpComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      location: 'home' | 'office';
      action: ClockAction;
      clockInCount: number;
      predefinedClockInCount: number;
    }
  ) {
    this.preDefined_max_clockIn_count = this.data.predefinedClockInCount;
    this.setDialogContent();
  }

  setDialogContent() {
    this.location_home = 'home.';
    this.location_office = 'office.';
    if (this.data.action === ClockAction.CLOCK_IN) {
      this.title = 'Are You Sure?';
      this.message = 'You are trying to clock in today as working from ';
      this.message_two = "You can't change this action once you proceed.";
      this.warningMsg = 'Do you wish to proceed?';
    } else if (this.data.action === ClockAction.CLOCK_OUT) {
      this.title = 'Are You Sure?';
      if (this.data.clockInCount == this.preDefined_max_clockIn_count - 1) {
        this.lastClockIn = true;
        this.message =
          "You are trying to clock out for the day. You can't clock in again today.";
      } else {
        this.message = 'You are trying to clock out now from working as';
        this.message_two = "You can't change this action once you proceed.";
      }
      this.warningMsg = 'Do you wish to proceed?';
    }
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }
}
